module.exports = __webpack_public_path__ + "static/media/Siren.b9c1cf6c.mp3";